import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ReportSubscription } from './reports-service';

export interface ReportFormData {
  uid?: string;
  reportType?: string | 'entity' | 'portfolio';
  active: boolean;
  reportObject?: string;
  portfolioName?: string;
  entityName?: string;
  schedule?: string;
  score: string;
  recipients: string[];
  isNew: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ReportsSetupFormService {
  private defaultReportForm: ReportFormData = {
    uid: undefined,
    reportType: 'entity',
    active: true,
    reportObject: undefined,
    schedule: undefined,
    score: '',
    recipients: [],
    isNew: true,
  };

  private currentReportSubject = new BehaviorSubject<ReportFormData>(
    this.defaultReportForm,
  );
  public currentReport$ = this.currentReportSubject.asObservable();

  constructor() {}

  getCurrentReport(): ReportFormData {
    return this.currentReportSubject.getValue();
  }

  setCurrentReport(report: ReportFormData): void {
    this.currentReportSubject.next(report);
  }

  createNewReport(): void {
    this.currentReportSubject.next({ ...this.defaultReportForm });
  }

  resetForm(): void {
    this.currentReportSubject.next({ ...this.defaultReportForm });
  }

  setupReportFromSubscription(subscription: ReportFormData): void {
    const reportForm: ReportFormData = {
      uid: subscription.uid,
      reportType: subscription.reportType || 'entity',
      active: subscription.active,
      entityName: subscription.entityName,
      portfolioName: subscription.portfolioName,
      reportObject: subscription.reportObject,
      schedule: subscription.schedule,
      score: subscription.score,
      recipients: subscription.recipients,
      isNew: false,
    };

    this.setCurrentReport(reportForm);
  }

  convertFormToSubscription(
    formData: ReportFormData,
  ): Omit<ReportSubscription, 'uid'> | ReportSubscription {
    const subscription: ReportSubscription = {
      displayable: `ylrn:displayable:${formData.reportType}:${formData.reportObject}`,
      active: formData.active,
      schedule: formData.schedule || '',
      score: formData.score,
      recipients: formData.recipients,
    };

    if (formData.uid) {
      subscription.uid = formData.uid;
    }

    return subscription;
  }
}
